import React from 'react';

import styled from 'styled-components';

const Container = styled.div`
  border-top: 1px solid #ebebeb;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fff;
  z-index: 1;

  @media (max-width: 768px) {
   margin-bottom: -20px;
    }
`;

const Content = styled.div`
  color: #6a6a6a;
  max-width: 1440px;
  height: 160px;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  i {
    color: #ce1720;
    font-size: 30px;
    margin: 25px 8px;
  }
`;

function Footer() {
  return (
    <Container>
      <Content>
        <span>Copyright © 2020 Kacareco • Todos os direitos reservados.</span>
        <p>
          <a href="https://instagram.com">
            {' '}
            <i className="fab fa-instagram" />{' '}
          </a>
          <a href="https://facebook.com">
            {' '}
            <i className="fab fa-facebook" />{' '}
          </a>
        </p>
      </Content>
    </Container>
  );
}

export default Footer;
